import AdditionalProduct from './views/AdditionalProduct';
export default AdditionalProduct;
